import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Fade,
  Modal,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  addAusencia,
  getAcolitosActivos,
  getPeriodosAusencia,
} from "../../helpers/acolitos";
import { Calendar, Loading } from "../../common/components";
import dayjs from "dayjs";
import { Add, Cancel, Save } from "@mui/icons-material";
import "dayjs/locale/es";

export const Ausencias = () => {
  //nombre de la pestaña
  document.title = "Periodos de ausencia";
  const [ausenciasActivas, setAusenciasActivas] = useState([]);
  const [ausenciasInactivas, setAusenciasInactivas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [txtLoading, setTxtLoading] = useState("Obteniendo periodos ausencia");
  const [acolitos, setAcolitos] = useState([]);
  const [formPeriodo, setFormPeriodo] = useState({
    id_periodo: 1,
    id_acolito: "",
    fecha_inicio: dayjs().format("YYYY-MM-DD"),
    fecha_termino: "",
    observaciones: "",
  });
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(
    "Error: faltan campos por llenar."
  );

  const getData = async () => {
    const ausencias = await getPeriodosAusencia(true);
    setAusenciasActivas(ausencias);
    const ausenciasInactivas = await getPeriodosAusencia("false");
    setAusenciasInactivas(ausenciasInactivas);
    const ac = await getAcolitosActivos();
    setAcolitos(ac["data"]);
    setLoading(false);
  };

  const validarCampos = () => {
    setErrorAlert("Error: faltan campos por llenar.");
    if (formPeriodo.id_acolito === "" || formPeriodo.id_acolito === null) {
      return false;
    }

    if (
      formPeriodo.fecha_inicio === "" ||
      formPeriodo.fecha_inicio === null ||
      formPeriodo.fecha_inicio === "Invalid Date"
    ) {
      return false;
    }
    if (
      formPeriodo.fecha_termino === "" ||
      formPeriodo.fecha_termino === null ||
      formPeriodo.fecha_termino === "Invalid Date"
    ) {
      return false;
    }

    if (formPeriodo.observaciones === "") {
      return false;
    }

    //Si la fecha de término es menor a la fecha de inicio
    if (dayjs(formPeriodo.fecha_termino).isBefore(formPeriodo.fecha_inicio)) {
      setErrorAlert(
        "Error: la fecha de término es menor a la fecha de inicio."
      );
      return false;
    }

    return true;
  };

  const guardarCambios = async () => {
    setLoading(true);
    if (!validarCampos()) {
      setShowAlert(true);
    } else {
      const resp = await addAusencia(formPeriodo);
      if (resp.status === 200) {
        // recargar página
        getData();
        setShowModal(false);
        setFormPeriodo({
          id_periodo: 1,
          id_acolito: "",
          fecha_inicio: dayjs().format("YYYY-MM-DD"),
          fecha_termino: "",
          observaciones: "",
        });
      } else {
        console.log("Hubo algún error");
      }
    }
    setTxtLoading("Guardando periodo de ausencia");
    setBtnDisabled(false);
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  if (loading) {
    return <Loading texto={txtLoading} />;
  }

  return (
    <Fade in={true} timeout={1000}>
      <Box sx={style.modal}>
        <Typography
          id="transition-modal-title"
          variant="h4"
          sx={style.modal_title}
          color="primary"
          fontWeight={900}
        >
          PERIODOS DE AUSENCIA ACTIVOS
        </Typography>
        <Box
          sx={{
            padding: 5,
            borderRadius: 7,
            //Agregar sombra
            boxShadow: 5,
            width: "95%",
            margin: "auto",
          }}
        >
          <Box
            sx={{
              display: "flex",
            }}
          >
            <Box
              sx={{
                width: "28%",
                marginRight: 5,
              }}
            >
              <Typography variant="h6" color="primary" sx={{ marginBottom: 2 }}>
                Nombre del acólito
              </Typography>
            </Box>
            <Box
              sx={{
                width: "12%",
                textAlign: "center",
                marginRight: 5,
              }}
            >
              <Typography variant="h6" color="primary" sx={{ marginBottom: 2 }}>
                Fecha de inicio
              </Typography>
            </Box>
            <Box
              sx={{
                width: "15%",
                textAlign: "center",
                marginRight: 5,
              }}
            >
              <Typography variant="h6" color="primary" sx={{ marginBottom: 2 }}>
                Fecha de término
              </Typography>
            </Box>
            <Box
              sx={{
                width: "32%",
                textAlign: "center",
                marginRight: 5,
              }}
            >
              <Typography variant="h6" color="primary" sx={{ marginBottom: 2 }}>
                Observaciones
              </Typography>
            </Box>
          </Box>

          {ausenciasActivas.length === 0 && (
            <Box
              sx={{
                textAlign: "center",
                marginTop: 5,
              }}
            >
              <Typography variant="h6" color="secondary.dark">
                No hay periodos de ausencia activos
              </Typography>
            </Box>
          )}

          {ausenciasActivas.map((ausencia) => (
            <Box
              key={ausencia.id_periodo}
              sx={{
                display: "flex",
                marginBottom: 2,
              }}
            >
              <Box
                sx={{
                  width: "28%",
                  marginRight: 5,
                }}
              >
                <Typography variant="body1" color="black" fontWeight={500}>
                  {ausencia.nombre_completo}
                </Typography>
              </Box>
              <Box
                sx={{
                  width: "12%",
                  textAlign: "center",
                  marginRight: 5,
                }}
              >
                <Typography variant="body1" color="secondary.dark">
                  {/* Mostrar solo el día, omitir la hora*/}
                  {dayjs(ausencia.fecha_inicio).format("DD/MM/YYYY")}
                </Typography>
              </Box>
              <Box
                sx={{
                  width: "15%",
                  marginRight: 5,
                  textAlign: "center",
                }}
              >
                <Typography variant="body1" color="secondary.dark">
                  {dayjs(ausencia.fecha_termino).format("DD/MM/YYYY")}
                </Typography>
              </Box>
              <Box
                sx={{
                  width: "32%",
                  textAlign: "center",
                }}
              >
                <Typography variant="body1" color="secondary.dark">
                  {ausencia.observaciones}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {/* Editar ausencia */}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setFormPeriodo({
                      id_periodo: ausencia.id_periodo,
                      id_acolito: ausencia.id_acolito,
                      fecha_inicio: ausencia.fecha_inicio,
                      fecha_termino: ausencia.fecha_termino,
                      observaciones: ausencia.observaciones,
                    });
                    setShowModal(true);
                  }}
                >
                  Editar
                </Button>
              </Box>
            </Box>
          ))}
          <Box sx={{ textAlign: "center", marginTop: 5 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setShowModal(true)}
            >
              <Add />
              Agregar ausencia
            </Button>
          </Box>
        </Box>
        <Box
          sx={{
            marginTop: 7,
          }}
        >
          <Typography
            id="transition-modal-title"
            variant="h4"
            sx={style.modal_title}
            color="primary"
            fontWeight={900}
          >
            PERIODOS DE AUSENCIA PASADOS
          </Typography>
        </Box>
        <Box
          sx={{
            padding: 5,
            borderRadius: 7,
            //Agregar sombra
            boxShadow: 5,
            width: "95%",
            margin: "auto",
          }}
        >
          <Box
            sx={{
              display: "flex",
            }}
          >
            <Box
              sx={{
                width: "28%",
                marginRight: 5,
              }}
            >
              <Typography variant="h6" color="primary" sx={{ marginBottom: 2 }}>
                Nombre del acólito
              </Typography>
            </Box>
            <Box
              sx={{
                width: "12%",
                textAlign: "center",
                marginRight: 5,
              }}
            >
              <Typography variant="h6" color="primary" sx={{ marginBottom: 2 }}>
                Fecha de inicio
              </Typography>
            </Box>
            <Box
              sx={{
                width: "15%",
                textAlign: "center",
                marginRight: 5,
              }}
            >
              <Typography variant="h6" color="primary" sx={{ marginBottom: 2 }}>
                Fecha de término
              </Typography>
            </Box>
            <Box
              sx={{
                width: "32%",
                textAlign: "center",
                marginRight: 5,
              }}
            >
              <Typography variant="h6" color="primary" sx={{ marginBottom: 2 }}>
                Observaciones
              </Typography>
            </Box>
          </Box>
          {ausenciasInactivas.map((ausencia) => (
            <Box
              key={ausencia.id_periodo}
              sx={{
                display: "flex",
                marginBottom: 2,
              }}
            >
              <Box
                sx={{
                  width: "28%",
                  marginRight: 5,
                }}
              >
                <Typography variant="body1" color="black" fontWeight={500}>
                  {ausencia.nombre_completo}
                </Typography>
              </Box>
              <Box
                sx={{
                  width: "12%",
                  textAlign: "center",
                  marginRight: 5,
                }}
              >
                <Typography variant="body1" color="secondary.dark">
                  {/* Mostrar solo el día, omitir la hora*/}
                  {dayjs(ausencia.fecha_inicio).format("DD/MM/YYYY")}
                </Typography>
              </Box>
              <Box
                sx={{
                  width: "15%",
                  marginRight: 5,
                  textAlign: "center",
                }}
              >
                <Typography variant="body1" color="secondary.dark">
                  {dayjs(ausencia.fecha_termino).format("DD/MM/YYYY")}
                </Typography>
              </Box>
              <Box
                sx={{
                  width: "32%",
                  textAlign: "center",
                }}
              >
                <Typography variant="body1" color="secondary.dark">
                  {ausencia.observaciones}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
        {/* Modal en donde se agregarán los nuevos periodos de ausencia */}
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={showModal}
          //   onClose={() => setShowModal(false)}
          closeAfterTransition
        >
          <Fade in={showModal} timeout={700}>
            <Box
              sx={{
                ...style.modal,
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                boxShadow: 24,
                borderRadius: 2,
              }}
            >
              <Typography
                id="transition-modal-title"
                variant="h4"
                sx={style.modal_title}
                color="primary"
                fontWeight={900}
                style={{ marginBottom: 10 }}
              >
                Agregar periodo de ausencia
              </Typography>
              <Typography
                variant="h7"
                sx={{
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                }}
                color="secondary.dark"
              >
                A continuación, llene los datos correspondientes
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  marginTop: 5,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    marginRight: 5,
                    width: 250,
                    textAlign: "right",
                  }}
                >
                  <Typography variant="h6" color="primary" fontWeight={600}>
                    Seleccione el acólito:
                  </Typography>
                </Box>
                <Autocomplete
                  options={acolitos}
                  getOptionLabel={(option) => option.nombre_completo}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  value={
                    acolitos.find(
                      (acolito) => acolito.id === formPeriodo.id_acolito
                    ) || null
                  }
                  style={{ width: 300 }}
                  renderInput={(params) => (
                    <TextField {...params} label="Nombre del acólito" />
                  )}
                  onChange={(event, value) => {
                    value
                      ? setFormPeriodo({ ...formPeriodo, id_acolito: value.id })
                      : setFormPeriodo({ ...formPeriodo, id_acolito: null });
                  }}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  marginTop: 5,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    marginRight: 5,
                    width: 250,
                    textAlign: "right",
                  }}
                >
                  <Typography variant="h6" color="primary" fontWeight={600}>
                    Fecha de inicio:
                  </Typography>
                </Box>
                <Calendar
                  fecha={formPeriodo.fecha_inicio}
                  setFecha={(fecha) =>
                    setFormPeriodo({
                      ...formPeriodo,
                      fecha_inicio: fecha.fecha,
                    })
                  }
                  sx={{
                    width: 300,
                  }}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  marginTop: 5,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    marginRight: 5,
                    width: 250,
                    textAlign: "right",
                  }}
                >
                  <Typography variant="h6" color="primary" fontWeight={600}>
                    Fecha de término:
                  </Typography>
                </Box>
                <Calendar
                  fecha={formPeriodo.fecha_termino}
                  setFecha={(fecha) => {
                    setFormPeriodo({
                      ...formPeriodo,
                      fecha_termino: fecha.fecha,
                    });
                  }}
                  sx={{
                    width: 300,
                  }}
                />
              </Box>
              <Box
                sx={{
                  //   display: "flex",
                  marginTop: 3,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h6"
                  color="primary"
                  sx={{
                    marginRight: 5,
                    marginBottom: 1,
                  }}
                  fontWeight={600}
                >
                  Observaciones
                </Typography>
                <TextField
                  value={formPeriodo.observaciones}
                  onChange={(e) => {
                    setFormPeriodo({
                      ...formPeriodo,
                      observaciones: e.target.value,
                    });
                  }}
                  id="outlined-multiline-static"
                  multiline
                  rows={2}
                  variant="outlined"
                  //   style={{ width: 300 }}
                  fullWidth
                />
              </Box>
              <Box
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 20,
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ marginRight: 7 }}
                  // Poner el icono en base a la propiedad iconBtn1
                  startIcon={<Save />}
                  onClick={guardarCambios}
                  disabled={btnDisabled}
                >
                  Guardar
                </Button>
                <Button
                  variant="contained"
                  color={"error"}
                  startIcon={<Cancel />}
                  onClick={() => {
                    setShowModal(false);
                    setFormPeriodo({
                      id_periodo: 1,
                      id_acolito: "",
                      fecha_inicio: dayjs().format("YYYY-MM-DD"),
                      fecha_termino: "",
                      observaciones: "",
                    });
                  }}
                  disabled={btnDisabled}
                >
                  Cancelar
                </Button>
              </Box>
            </Box>
          </Fade>
        </Modal>
        {/* Alerta de error */}
        <Snackbar
          open={showAlert}
          autoHideDuration={6000}
          onClose={() => setShowAlert(false)}
        >
          <Alert
            onClose={() => setShowAlert(false)}
            severity="error"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {errorAlert}
          </Alert>
        </Snackbar>
      </Box>
    </Fade>
  );
};

const style = {
  modal: {
    // position: "absolute",
    top: "50%",
    left: "50%",
    // transform: "translate(-50%, -50%)",
    // width: "65%",
    bgcolor: "background.paper",
    // boxShadow: 24,
    p: 4,
    // borderRadius: 2,
  },
  modal_title: {
    textAlign: "center",
    marginBottom: 5,
  },
  inputs: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 5,
    justifyContent: "space-around",
  },
};
